import 'bootstrap/js/tooltip';
import $ from 'jquery';
import { addProductToCart } from './cart';
import Swal from './sweetalert/polyfilled-sweetalert2';
$('.js-show-tooltip').tooltip();
const $quantityInput = $('.js-quantity');
$quantityInput.on('change blur', function () {
    if (this.value < this.min) {
        this.value = this.min;
        for (let i = 0; i < 4000; i += 500) {
            setTimeout(() => {
                ;
                this.parentElement.classList.toggle('has-error');
            }, i);
        }
    }
    else {
        ;
        this.parentElement.classList.remove('has-error');
    }
});
$quantityInput.tooltip();
$('.js-add-to-cart').on('click', function (e) {
    e.preventDefault();
    const quantityInput = this.closest('tr').querySelector('.js-quantity');
    const minimalQuantity = Number(quantityInput?.min ?? 1);
    if (quantityInput && quantityInput.valueAsNumber < minimalQuantity) {
        Swal.fire({ title: `Permažas kiekis, minimalus užsakomas kiekis: ${minimalQuantity}vnt.`, icon: 'warning' });
        quantityInput.valueAsNumber = minimalQuantity;
        e.stopPropagation();
        return;
    }
    addProductToCart(this.dataset.id, this.dataset.partNumber, quantityInput?.valueAsNumber ?? 0, Number(this.dataset.priceWithoutVat), this.dataset.manufacturer, this.dataset.supplier, minimalQuantity, Number(this.dataset.priceWithVat));
});
$(document).on('click', '.tooltip', function () {
    const newPartNumber = $(this).closest('td')?.data('new');
    if (newPartNumber) {
        window.location = `/search?search=${newPartNumber}`;
    }
});
